export type BookingColumn = {
  id: string
  label: string
  /** Track width in design px. */
  width: number
  align: 'left' | 'center'
  /** Disambiguates the two columns the design both labels "Status". */
  srSuffix?: string
}

/** Column tracks measured from the design; the gaps between them flex with the card. */
export const bookingColumns: BookingColumn[] = [
  { id: 'customer', label: 'Customer', width: 109, align: 'left' },
  { id: 'reference', label: 'Booking ID', width: 72.333, align: 'left' },
  { id: 'route', label: 'Type', width: 127, align: 'left' },
  { id: 'schedule', label: 'Date & Time', width: 93, align: 'left' },
  { id: 'vehicle', label: 'Vehicle', width: 134, align: 'left' },
  { id: 'amount', label: 'Amount', width: 75.333, align: 'left' },
  { id: 'payment', label: 'Status', width: 47, align: 'center', srSuffix: 'Payment' },
  { id: 'trip', label: 'Status', width: 101, align: 'center', srSuffix: 'Trip' },
  { id: 'actions', label: 'Actions', width: 50, align: 'center' },
]

export const BOOKINGS_GRID = bookingColumns.map((column) => `${column.width}px`).join(' ')

/** Width at which the design's 52px column gaps are reproduced exactly. */
export const BOOKINGS_MIN_WIDTH = 1225
